import { cn } from '@/utils/cn';

type Tone = 'empty' | 'error';

interface SectionMessageProps {
  readonly title?: string;
  readonly tone: Tone;
  readonly message: string;
}

const TONE_CLASS: Record<Tone, string> = {
  empty: 'text-muted',
  error: 'text-destructive',
};

/**
 * The empty and degraded states of a section (US-007, US-011). A section always renders one of these
 * rather than going blank, and never shows an API error body.
 *
 * Loading is no longer one of them: it is a skeleton now, in `LoadingSection`.
 */
export function SectionMessage({ title, tone, message }: SectionMessageProps): React.JSX.Element {
  return (
    <section className="border-line rounded-xl border bg-surface p-6 shadow-sm">
      {title !== undefined && (
        <h2 className="text-brand-600 border-line border-b pb-3 text-lg font-bold">{title}</h2>
      )}
      <p
        role={tone === 'error' ? 'alert' : 'status'}
        className={cn('py-6 text-center text-sm', TONE_CLASS[tone])}
      >
        {message}
      </p>
    </section>
  );
}
